import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Close from '../../../assets/images/close.svg';
import Loading from '../../../components/Common/Loading';

import { actionSendOTP } from '../../../store/application/actions';

function SendPhoneNumber() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [showPopup, setShowPopup] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = async (data) => {
    const response = await dispatch(
      actionSendOTP({
        phone: data.phone,
        product_code: 'register',
      }),
    );
    if (response?.sts_code === 0) {
      navigate('/application-otp', { state: { phone: data.phone } });
    }
  };

  return (
    <>
      <Loading isVisible={isSubmitting} />
      <div className="p-10 pt-36 fixed w-full z-10 top-0 left-0 flex items-start justify-center h-full" style={{ backgroundColor: '#0000004d' }}>
        <div className={`rounded-md w-full border-primary py-6 px-8 bg-white ${showPopup ? 'h-[265px]' : ''}`} style={{ maxWidth: 414 }}>
          <div className="flex justify-between items-center">
            <p className="flex-1 text-2xl text-primary2 text-center font-semibold pt-3">申請Cashing Pro貸款</p>
          </div>
          {showPopup && <div className='flex justify-center items-center flex-col space-y-6 my-7 mb-16'>
            <button onClick={()=> setShowPopup(false)} type="button" className={`rounded-full text-white text-lg px-20 h-[54px] bg-primary`}>
              新客戶
            </button>
            <button onClick={() => setShowPopup(false)} type="button" className={`rounded-full text-white text-lg px-20 h-[54px] bg-primary2`}>
              舊客戶
            </button>
          </div>}
          {!showPopup && <form onSubmit={handleSubmit(onSubmit)}>
            <p className="text-gray mt-7 mb-1 text-xl">手提電話號碼</p>
            <input
              {...register('phone', {
                required: true,
                pattern: /^[4-9][0-9]{7}$/g,
                onChange: (e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))
              })}
              value={phone}
              className="border-0 border-b-2 border-primary2 text-primary2 w-full h-10 outline-none px-2"
              style={{ marginBottom: -5 }}
              maxLength={8}
              inputMode={'numeric'}
              placeholder='(按此輸入)'
            />
            {errors.phone && errors.phone.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
            {errors.phone && errors.phone.type === 'pattern' && <span className="text-10 text-red-500">*請輸入正確的手提電話號碼</span>}
            <p className="text-10 mt-8 text-gray">
              我們將會發送一次性驗證碼到閣下輸入之手提電話號碼，
              <span className="text-primary">
                提交前請確認所輸入之手提電話號碼正確無誤。
              </span>
            </p>
            <p className="text-10 text-gray mt-6">
              您申請代表您已詳閱並接受我們的{' '}
              <a href={`${process.env.REACT_APP_HOME_URL}/website-terms/`} className="text-primary underline" target="_blank" rel="noreferrer">
                網站使用條款
              </a>
              {' '}
              及
              {' '}
              <a href={`${process.env.REACT_APP_HOME_URL}/privacy-policy-and-personal-information-collection-statement/`} className="text-primary underline" target="_blank" rel="noreferrer">
                私隱政策及收集個人資料聲明
              </a>
              ，亦同意 Cashing Pro Limited 經電話及短訊通知你有關貸款的服務信息
            </p>
            <div className="flex justify-center mt-5 mb-3">
              <button type="submit" disabled={isSubmitting} className={`rounded-full text-white text-sm px-12 py-3 ${isSubmitting ? 'bg-mercury' : 'bg-primary'}`}>
                確定
              </button>
            </div>
          </form>}
        </div>
      </div>
    </>
  );
}

export default SendPhoneNumber;
